<template>
  <div class="Tips">
    <!-- <myHead :title="title" :subtitle="subtitle" v-on:goBack="handleBack" @getFooter="getFooter" :back="true" /> -->
    <my-head :title="title" :subtitle="subtitle" v-on:goBack="handleBack" @getFooter="getFooter"  :getMatchHeaderId="this.getMatchHeaderId" :back="true" >

    </my-head>
    <div class="Tips-content" v-html="content"></div>
        <div id="footer" v-if="footer">
      <span>{{footer}} </span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { GetArticle } from "@/request/api";
import myHead from "@/components/myHead.vue";
import { Icon } from "vant";

export default {
  name: "Tips",
  data() {
    return {
      title: "",
      subtitle: "",
      content:"",
      footer:"",
      getMatchHeaderId: localStorage.getItem("getMatchHeaderId")
    };
  },
  components: {
    [Icon.name]: Icon,
    myHead
  },
  computed: {
    width: function() {
      return document.body.clientWidth;
    }
  },
  mounted(){
    GetArticle(this.$route.params.id).then(res=>{
      if(res.success){
        const {name,content} = res.data;
        this.title = name ;
        this.content = content
      }
    })
  },
  methods: {
    handleBack: function() {
      console.log("返回");
      this.$router.go(-1);
    },
    getFooter:function(val){
      this.footer = val
    },
    hanhdleClick: e => {
      console.log(e);
    }
  }
};
</script>

<style lang="less">
</style>
<style scoped lang="less">
.Tips-content{
  padding: 30px;
  font-size: 16px;
}
</style>
